// src/store/themeSlice.js
import { createSlice } from '@reduxjs/toolkit';
const initial = localStorage.getItem('theme')

const initialState = {
    color: initial ? initial : 'default',
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.color = action.payload;
        },
    },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
